// extracted by mini-css-extract-plugin
module.exports = {"container":"Popover_container__vGBnN","content":"Popover_content__9BsrP","appear":"Popover_appear___nV0_","arrow":"Popover_arrow__b0SaA"};